import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faEnvelope,
  faPhone,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { SUPPORT_CONTACTS } from "../../../../services/supportTicket";
import styles from "./LandingRegisterForm.module.css";

const LandingRegisterForm = ({
  formTitle,
  formSubtitle,
  ctaLabel,
  loginLinkText,
  contactTitle = "Contáctanos",
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <h2 className={styles.title}>{formTitle}</h2>
        {formSubtitle?.trim() && (
          <p className={styles.subtitle}>{formSubtitle}</p>
        )}
      </div>

      <Link
        to="/auth"
        state={{ mode: "registro", returnTo: "/apuestas" }}
        className={styles.cta}
      >
        {ctaLabel}
        <FontAwesomeIcon icon={faArrowRight} className={styles.ctaIcon} />
      </Link>

      <div className={styles.contactBlock}>
        <h3 className={styles.contactTitle}>{contactTitle}</h3>
        <ul className={styles.contactList}>
          <li>
            <a href={SUPPORT_CONTACTS.phoneTel} className={styles.contactPhone}>
              <FontAwesomeIcon icon={faPhone} className={styles.contactIcon} />
              <span>{SUPPORT_CONTACTS.phoneDisplay}</span>
            </a>
          </li>
          <li>
            <a
              href={`mailto:${SUPPORT_CONTACTS.premiosEmail}`}
              className={styles.contactItem}
            >
              <FontAwesomeIcon icon={faEnvelope} className={styles.contactIcon} />
              <span>Premios: {SUPPORT_CONTACTS.premiosEmail}</span>
            </a>
          </li>
          <li>
            <a
              href={`mailto:${SUPPORT_CONTACTS.soporteEmail}`}
              className={styles.contactItem}
            >
              <FontAwesomeIcon icon={faEnvelope} className={styles.contactIcon} />
              <span>Mail: {SUPPORT_CONTACTS.soporteEmail}</span>
            </a>
          </li>
          <li>
            <a
              href={SUPPORT_CONTACTS.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactItem}
            >
              <FontAwesomeIcon
                icon={faLocationDot}
                className={styles.contactIcon}
              />
              <span>{SUPPORT_CONTACTS.address}</span>
            </a>
          </li>
        </ul>
      </div>

      <p className={styles.loginHint}>
        <Link
          to="/auth"
          state={{ mode: "login", returnTo: "/apuestas" }}
          className={styles.loginLink}
        >
          {loginLinkText}
        </Link>
      </p>
    </div>
  );
};

export default LandingRegisterForm;
